import { useRouter } from "vue-router";
import { reactive, watch } from "vue";

const usePagination = () => {
  const { currentRoute, replace } = useRouter();
  const { query } = currentRoute.value;
  const { page } = query;

  const pagination = reactive({
    currentPage: !!page ? parseInt(query.toString(), 10) : 1,
    links: [],
    meta: {},
    data: [],
  });

  /**
   * Remove "page" from query string when
   * page is 1
   *
   * @param params
   * @returns {Promise<void>}
   */
  const replaceParams = async (params: any) => {
    if (!!params.page && parseInt(params.page, 10) === 1) {
      const tmp = { ...params };
      delete tmp.page;

      await replace({ query: tmp });
    }
  };

  replaceParams(query);
  watch(() => currentRoute.value.query, replaceParams);

  const setResponse = (response: any) => {
    pagination.links = response.links;
    pagination.meta = response.meta;
    pagination.data = response.data;
  };

  const setResponseV2 = (response: any) => {
    const res = response.data ?? response?.content;
    pagination.links = res.links;

    pagination.meta = {
      currentPage: res.current_page,
      lastPage: res.last_page,
      perPage: res.per_page,
      from: res.from,
      to: res.to,
      total: res.total,
      path: res.path,
    };

    pagination.data = res.data;
  };

  const changePage = async (newPage: any) => {
    await replace({
      query: {
        ...currentRoute.value.query,
        page: newPage,
      },
    });

    pagination.currentPage = parseInt(newPage, 10);
  };

  return {
    pagination,
    setResponse,
    changePage,
    setResponseV2,
  };
};

export default usePagination;
